export const getEstados = (state) => state.estados.lista
export const getIsCarregandoListaEstados = (state) => state.estados.isCarregandoLista
